/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AvailableFishGroupQuality} from '../bioplanModels';
// @ts-ignore
import type {CageResponse} from '../bioplanModels';
// @ts-ignore
import type {CageTimeSeriesRequest} from '../bioplanModels';
// @ts-ignore
import type {ConnectorData} from '../bioplanModels';
// @ts-ignore
import type {WriteCage} from '../bioplanModels';
/**
 * PlanningCageApi - axios parameter creator
 * @export
 */
export const PlanningCageApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get available fish group quality in a cage on a specific date
     * @param {string} cageId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdAvailableFishGroupQualityGet: async (
      cageId: string,
      date: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('cagesCageIdAvailableFishGroupQualityGet', 'cageId', cageId);
      // verify required parameter 'date' is not null or undefined
      assertParamExists('cagesCageIdAvailableFishGroupQualityGet', 'date', date);
      const localVarPath = `/cages/{cageId}/availableFishGroupQuality`.replace(
        `{${'cageId'}}`,
        encodeURIComponent(String(cageId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString().substring(0, 10) : date;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete cage by its identifier
     * @param {string} cageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdDelete: async (cageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('cagesCageIdDelete', 'cageId', cageId);
      const localVarPath = `/cages/{cageId}`.replace(`{${'cageId'}}`, encodeURIComponent(String(cageId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get cage by its identifier. Include children.
     * @param {string} cageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdGet: async (cageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('cagesCageIdGet', 'cageId', cageId);
      const localVarPath = `/cages/{cageId}`.replace(`{${'cageId'}}`, encodeURIComponent(String(cageId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update cage plan
     * @param {string} cageId
     * @param {WriteCage} writeCage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdPut: async (
      cageId: string,
      writeCage: WriteCage,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('cagesCageIdPut', 'cageId', cageId);
      // verify required parameter 'writeCage' is not null or undefined
      assertParamExists('cagesCageIdPut', 'writeCage', writeCage);
      const localVarPath = `/cages/{cageId}`.replace(`{${'cageId'}}`, encodeURIComponent(String(cageId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeCage, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get cage by its identifier
     * @param {string} cageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdSimpleGet: async (cageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('cagesCageIdSimpleGet', 'cageId', cageId);
      const localVarPath = `/cages/{cageId}/simple`.replace(`{${'cageId'}}`, encodeURIComponent(String(cageId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} cageId
     * @param {CageTimeSeriesRequest} cageTimeSeriesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdTimeseriesPost: async (
      cageId: string,
      cageTimeSeriesRequest: CageTimeSeriesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('cagesCageIdTimeseriesPost', 'cageId', cageId);
      // verify required parameter 'cageTimeSeriesRequest' is not null or undefined
      assertParamExists('cagesCageIdTimeseriesPost', 'cageTimeSeriesRequest', cageTimeSeriesRequest);
      const localVarPath = `/cages/{cageId}/timeseries`.replace(`{${'cageId'}}`, encodeURIComponent(String(cageId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(cageTimeSeriesRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary For a site and a date, get empty cages.
     * @param {string} siteId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesEmptyGet: async (siteId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('cagesEmptyGet', 'siteId', siteId);
      // verify required parameter 'date' is not null or undefined
      assertParamExists('cagesEmptyGet', 'date', date);
      const localVarPath = `/cages/empty`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString().substring(0, 10) : date;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all cage for a plan or site
     * @param {string} [planId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesGet: async (planId?: string, siteId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/cages/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary For a site and a date, get non-empty cages.
     * @param {string} siteId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesNonEmptyGet: async (
      siteId: string,
      date: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('cagesNonEmptyGet', 'siteId', siteId);
      // verify required parameter 'date' is not null or undefined
      assertParamExists('cagesNonEmptyGet', 'date', date);
      const localVarPath = `/cages/nonEmpty`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString().substring(0, 10) : date;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create cage for a site
     * @param {WriteCage} writeCage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesPost: async (writeCage: WriteCage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'writeCage' is not null or undefined
      assertParamExists('cagesPost', 'writeCage', writeCage);
      const localVarPath = `/cages/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeCage, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningCageApi - functional programming interface
 * @export
 */
export const PlanningCageApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningCageApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get available fish group quality in a cage on a specific date
     * @param {string} cageId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesCageIdAvailableFishGroupQualityGet(
      cageId: string,
      date: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvailableFishGroupQuality>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesCageIdAvailableFishGroupQualityGet(
        cageId,
        date,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesCageIdAvailableFishGroupQualityGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete cage by its identifier
     * @param {string} cageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesCageIdDelete(
      cageId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesCageIdDelete(cageId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesCageIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get cage by its identifier. Include children.
     * @param {string} cageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesCageIdGet(
      cageId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesCageIdGet(cageId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesCageIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update cage plan
     * @param {string} cageId
     * @param {WriteCage} writeCage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesCageIdPut(
      cageId: string,
      writeCage: WriteCage,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesCageIdPut(cageId, writeCage, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesCageIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get cage by its identifier
     * @param {string} cageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesCageIdSimpleGet(
      cageId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesCageIdSimpleGet(cageId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesCageIdSimpleGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} cageId
     * @param {CageTimeSeriesRequest} cageTimeSeriesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesCageIdTimeseriesPost(
      cageId: string,
      cageTimeSeriesRequest: CageTimeSeriesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorData>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesCageIdTimeseriesPost(
        cageId,
        cageTimeSeriesRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesCageIdTimeseriesPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary For a site and a date, get empty cages.
     * @param {string} siteId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesEmptyGet(
      siteId: string,
      date: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CageResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesEmptyGet(siteId, date, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesEmptyGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all cage for a plan or site
     * @param {string} [planId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesGet(
      planId?: string,
      siteId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CageResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesGet(planId, siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary For a site and a date, get non-empty cages.
     * @param {string} siteId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesNonEmptyGet(
      siteId: string,
      date: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CageResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesNonEmptyGet(siteId, date, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesNonEmptyGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create cage for a site
     * @param {WriteCage} writeCage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cagesPost(
      writeCage: WriteCage,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cagesPost(writeCage, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageApi.cagesPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningCageApi - factory interface
 * @export
 */
export const PlanningCageApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningCageApiFp(configuration);
  return {
    /**
     *
     * @summary Get available fish group quality in a cage on a specific date
     * @param {PlanningCageApiCagesCageIdAvailableFishGroupQualityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdAvailableFishGroupQualityGet(
      requestParameters: PlanningCageApiCagesCageIdAvailableFishGroupQualityGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<AvailableFishGroupQuality>> {
      return localVarFp
        .cagesCageIdAvailableFishGroupQualityGet(requestParameters.cageId, requestParameters.date, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete cage by its identifier
     * @param {PlanningCageApiCagesCageIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdDelete(
      requestParameters: PlanningCageApiCagesCageIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .cagesCageIdDelete(requestParameters.cageId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get cage by its identifier. Include children.
     * @param {PlanningCageApiCagesCageIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdGet(
      requestParameters: PlanningCageApiCagesCageIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CageResponse> {
      return localVarFp.cagesCageIdGet(requestParameters.cageId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update cage plan
     * @param {PlanningCageApiCagesCageIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdPut(
      requestParameters: PlanningCageApiCagesCageIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CageResponse> {
      return localVarFp
        .cagesCageIdPut(requestParameters.cageId, requestParameters.writeCage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get cage by its identifier
     * @param {PlanningCageApiCagesCageIdSimpleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdSimpleGet(
      requestParameters: PlanningCageApiCagesCageIdSimpleGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CageResponse> {
      return localVarFp
        .cagesCageIdSimpleGet(requestParameters.cageId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PlanningCageApiCagesCageIdTimeseriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesCageIdTimeseriesPost(
      requestParameters: PlanningCageApiCagesCageIdTimeseriesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ConnectorData> {
      return localVarFp
        .cagesCageIdTimeseriesPost(requestParameters.cageId, requestParameters.cageTimeSeriesRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary For a site and a date, get empty cages.
     * @param {PlanningCageApiCagesEmptyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesEmptyGet(
      requestParameters: PlanningCageApiCagesEmptyGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CageResponse>> {
      return localVarFp
        .cagesEmptyGet(requestParameters.siteId, requestParameters.date, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all cage for a plan or site
     * @param {PlanningCageApiCagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesGet(
      requestParameters: PlanningCageApiCagesGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CageResponse>> {
      return localVarFp
        .cagesGet(requestParameters.planId, requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary For a site and a date, get non-empty cages.
     * @param {PlanningCageApiCagesNonEmptyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesNonEmptyGet(
      requestParameters: PlanningCageApiCagesNonEmptyGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CageResponse>> {
      return localVarFp
        .cagesNonEmptyGet(requestParameters.siteId, requestParameters.date, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create cage for a site
     * @param {PlanningCageApiCagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cagesPost(
      requestParameters: PlanningCageApiCagesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CageResponse> {
      return localVarFp.cagesPost(requestParameters.writeCage, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for cagesCageIdAvailableFishGroupQualityGet operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesCageIdAvailableFishGroupQualityGetRequest
 */
export interface PlanningCageApiCagesCageIdAvailableFishGroupQualityGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesCageIdAvailableFishGroupQualityGet
   */
  readonly cageId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesCageIdAvailableFishGroupQualityGet
   */
  readonly date: string;
}

/**
 * Request parameters for cagesCageIdDelete operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesCageIdDeleteRequest
 */
export interface PlanningCageApiCagesCageIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesCageIdDelete
   */
  readonly cageId: string;
}

/**
 * Request parameters for cagesCageIdGet operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesCageIdGetRequest
 */
export interface PlanningCageApiCagesCageIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesCageIdGet
   */
  readonly cageId: string;
}

/**
 * Request parameters for cagesCageIdPut operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesCageIdPutRequest
 */
export interface PlanningCageApiCagesCageIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesCageIdPut
   */
  readonly cageId: string;

  /**
   *
   * @type {WriteCage}
   * @memberof PlanningCageApiCagesCageIdPut
   */
  readonly writeCage: WriteCage;
}

/**
 * Request parameters for cagesCageIdSimpleGet operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesCageIdSimpleGetRequest
 */
export interface PlanningCageApiCagesCageIdSimpleGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesCageIdSimpleGet
   */
  readonly cageId: string;
}

/**
 * Request parameters for cagesCageIdTimeseriesPost operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesCageIdTimeseriesPostRequest
 */
export interface PlanningCageApiCagesCageIdTimeseriesPostRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesCageIdTimeseriesPost
   */
  readonly cageId: string;

  /**
   *
   * @type {CageTimeSeriesRequest}
   * @memberof PlanningCageApiCagesCageIdTimeseriesPost
   */
  readonly cageTimeSeriesRequest: CageTimeSeriesRequest;
}

/**
 * Request parameters for cagesEmptyGet operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesEmptyGetRequest
 */
export interface PlanningCageApiCagesEmptyGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesEmptyGet
   */
  readonly siteId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesEmptyGet
   */
  readonly date: string;
}

/**
 * Request parameters for cagesGet operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesGetRequest
 */
export interface PlanningCageApiCagesGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesGet
   */
  readonly planId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesGet
   */
  readonly siteId?: string;
}

/**
 * Request parameters for cagesNonEmptyGet operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesNonEmptyGetRequest
 */
export interface PlanningCageApiCagesNonEmptyGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesNonEmptyGet
   */
  readonly siteId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningCageApiCagesNonEmptyGet
   */
  readonly date: string;
}

/**
 * Request parameters for cagesPost operation in PlanningCageApi.
 * @export
 * @interface PlanningCageApiCagesPostRequest
 */
export interface PlanningCageApiCagesPostRequest {
  /**
   *
   * @type {WriteCage}
   * @memberof PlanningCageApiCagesPost
   */
  readonly writeCage: WriteCage;
}

/**
 * PlanningCageApi - object-oriented interface
 * @export
 * @class PlanningCageApi
 * @extends {BaseAPI}
 */
export class PlanningCageApi extends BaseAPI {
  /**
   *
   * @summary Get available fish group quality in a cage on a specific date
   * @param {PlanningCageApiCagesCageIdAvailableFishGroupQualityGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesCageIdAvailableFishGroupQualityGet(
    requestParameters: PlanningCageApiCagesCageIdAvailableFishGroupQualityGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningCageApiFp(this.configuration)
      .cagesCageIdAvailableFishGroupQualityGet(requestParameters.cageId, requestParameters.date, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete cage by its identifier
   * @param {PlanningCageApiCagesCageIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesCageIdDelete(
    requestParameters: PlanningCageApiCagesCageIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningCageApiFp(this.configuration)
      .cagesCageIdDelete(requestParameters.cageId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get cage by its identifier. Include children.
   * @param {PlanningCageApiCagesCageIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesCageIdGet(requestParameters: PlanningCageApiCagesCageIdGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningCageApiFp(this.configuration)
      .cagesCageIdGet(requestParameters.cageId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update cage plan
   * @param {PlanningCageApiCagesCageIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesCageIdPut(requestParameters: PlanningCageApiCagesCageIdPutRequest, options?: RawAxiosRequestConfig) {
    return PlanningCageApiFp(this.configuration)
      .cagesCageIdPut(requestParameters.cageId, requestParameters.writeCage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get cage by its identifier
   * @param {PlanningCageApiCagesCageIdSimpleGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesCageIdSimpleGet(
    requestParameters: PlanningCageApiCagesCageIdSimpleGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningCageApiFp(this.configuration)
      .cagesCageIdSimpleGet(requestParameters.cageId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PlanningCageApiCagesCageIdTimeseriesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesCageIdTimeseriesPost(
    requestParameters: PlanningCageApiCagesCageIdTimeseriesPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningCageApiFp(this.configuration)
      .cagesCageIdTimeseriesPost(requestParameters.cageId, requestParameters.cageTimeSeriesRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary For a site and a date, get empty cages.
   * @param {PlanningCageApiCagesEmptyGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesEmptyGet(requestParameters: PlanningCageApiCagesEmptyGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningCageApiFp(this.configuration)
      .cagesEmptyGet(requestParameters.siteId, requestParameters.date, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all cage for a plan or site
   * @param {PlanningCageApiCagesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesGet(requestParameters: PlanningCageApiCagesGetRequest = {}, options?: RawAxiosRequestConfig) {
    return PlanningCageApiFp(this.configuration)
      .cagesGet(requestParameters.planId, requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary For a site and a date, get non-empty cages.
   * @param {PlanningCageApiCagesNonEmptyGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesNonEmptyGet(requestParameters: PlanningCageApiCagesNonEmptyGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningCageApiFp(this.configuration)
      .cagesNonEmptyGet(requestParameters.siteId, requestParameters.date, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create cage for a site
   * @param {PlanningCageApiCagesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageApi
   */
  public cagesPost(requestParameters: PlanningCageApiCagesPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningCageApiFp(this.configuration)
      .cagesPost(requestParameters.writeCage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
